import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Table } from "@/components/erp/ui";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then(({ data }) => setRows(data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader title="Audit Trail" subtitle="Semua perubahan penting tercatat: who · what · when." />
      <Table testid="audit-table" columns={["Waktu","User","Role","Action","Module","Record"]} rows={rows} renderRow={(a) => (
        <tr key={a.id} className="border-b border-slate-100 last:border-0 hover:bg-slate-50">
          <td className="px-4 py-3 font-mono text-xs text-slate-500">{new Date(a.at).toLocaleString("id-ID")}</td>
          <td className="px-4 py-3">{a.user}</td>
          <td className="px-4 py-3 text-xs text-slate-500" data-testid={`audit-roles-${a.id}`}>{(a.roles || []).join(", ") || "-"}</td>
          <td className="px-4 py-3 font-medium">{a.action}</td>
          <td className="px-4 py-3">{a.module}</td>
          <td className="px-4 py-3 font-mono text-xs text-slate-500">{a.record || "-"}</td>
        </tr>
      )} />
    </div>
  );
}
